<ng-container *transloco="let t; prefix: 'products'">

    <nav class="breadcrumb" [attr.aria-label]="'products.ui.percorsoDiNavigazione' | transloco">
        @for (item of breadcrumbItems; track item.label; let last = $last) {
            @if (!last) {
                <span class="label-large emphasized">{{ item.label }}</span>
                <i class="fa-regular fa-chevron-right breadcrumb-separator"></i>
            } @else {
                <span class="label-large" aria-current="page">{{ item.label }}</span>
            }
        }
    </nav>

    @if (productDetail) {
        <mat-card class="product-card">
            <mat-card-content>
                <div class="product-card-header">
                    <span class="title-large emphasized">{{ productDetail.nomeProdotto }}</span>
                </div>

                <div class="product-card-subheader">
                    <span class="body-medium product-card-description">{{ productDetail.pimcore.descrizioneCompleta }}</span>
                </div>

                <div class="product-card-details-row">
                    <div class="product-card-detail-item">
                        <span class="body-medium">{{ 'products.ui.codProdotto' | transloco }}</span>
                        <span class="body-medium emphasized">{{ productDetail.sku }}</span>
                    </div>
                    <div class="product-card-detail-item">
                        <span class="body-medium">PLC1</span>
                        <span class="body-medium emphasized">{{ productDetail.plc1 }}</span>
                    </div>
                    <div class="product-card-detail-item">
                        <span class="body-medium">PLC2</span>
                        <span class="body-medium emphasized">{{ productDetail.plc2 }}</span>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>

        @if (productDetail.prodottoSostitutivo) {
            <mat-card class="substitute-card">
                <mat-card-content>
                    <div class="substitute-card-header">
                        <i class="fa-regular fa-circle-exclamation"></i>
                        <span class="body-medium emphasized substitute-card-title">{{ 'products.ui.prodottoInSostituzione' | transloco }}</span>
                    </div>

                    <div class="substitute-card-body">
                        <span class="body-medium">{{ 'products.ui.ilProdottoSaraSostituitoDa' | transloco: { value0: (productDetail.prodottoSostitutivo.nomeProdotto) } }}</span>
                        <button matButton class="substitute-card-link" (click)="openRelatedProduct(productDetail.prodottoSostitutivo.idProdottoMaster)">
                            <i class="fa-regular fa-up-right-from-square"></i>
                            {{ 'products.ui.visualizzaSostituto' | transloco }}
                        </button>
                    </div>
                </mat-card-content>
            </mat-card>
        }

        <mat-tab-group animationDuration="0ms" class="tabs" mat-align-tabs="start" mat-stretch-tabs="false">
            <mat-tab [label]="'products.ui.infoProdotto' | transloco">
                <div class="tab-content">

                    <span class="title-medium emphasized section-title">{{ 'products.ui.codiciDisponibili' | transloco }}</span>

                    <ui-table-view
                        class="available-codes-table table-view"
                        [data]="availableCodesTableData"
                        [columnsInfo]="availableCodesColumnsInfo">
                    </ui-table-view>

                    @if (productDetail.pimcore.descrizioneCompleta || productDetail.pimcore.applicazione || productDetail.pimcore.proprietaChimiche?.length || productDetail.pimcore.specifiche?.length) {
                        <span class="title-medium emphasized section-title">{{ 'products.ui.applicazioniTecnicheEProprietaChimiche' | transloco }}</span>
                    }

                    <div class="technical-info-row">
                        @if (productDetail.pimcore.descrizioneCompleta) {
                            <mat-expansion-panel class="technical-info-panel">
                                <mat-expansion-panel-header>
                                    <mat-panel-title class="title-small emphasized">{{ 'products.ui.descrizione' | transloco }}</mat-panel-title>
                                </mat-expansion-panel-header>
                                <span class="body-medium">{{ productDetail.pimcore.descrizioneCompleta }}</span>
                            </mat-expansion-panel>
                        }

                        @if (productDetail.pimcore.applicazione) {
                            <mat-expansion-panel class="technical-info-panel">
                                <mat-expansion-panel-header>
                                    <mat-panel-title class="title-small emphasized">{{ 'products.ui.applicazione' | transloco }}</mat-panel-title>
                                </mat-expansion-panel-header>
                                <span class="body-medium">{{ productDetail.pimcore.applicazione }}</span>
                            </mat-expansion-panel>
                        }

                        @if (productDetail.pimcore.proprietaChimiche?.length) {
                            <mat-expansion-panel class="technical-info-panel">
                                <mat-expansion-panel-header>
                                    <mat-panel-title class="title-small emphasized">{{ 'products.ui.proprietaChimiche' | transloco }}</mat-panel-title>
                                </mat-expansion-panel-header>
                                <ui-table-view
                                    class="chemical-properties-table"
                                    [data]="chemicalPropertiesTableData"
                                    [columnsInfo]="chemicalPropertiesColumnsInfo">
                                </ui-table-view>
                            </mat-expansion-panel>
                        }

                        @if (productDetail.pimcore.specifiche?.length) {
                            <mat-expansion-panel class="technical-info-panel">
                                <mat-expansion-panel-header>
                                    <mat-panel-title class="title-small emphasized">{{ 'products.ui.specifiche' | transloco }}</mat-panel-title>
                                </mat-expansion-panel-header>
                                <ui-table-view
                                    class="specifications-table"
                                    [data]="productDetail.pimcore.specifiche"
                                    [columnsInfo]="specificationsColumnsInfo">
                                </ui-table-view>
                            </mat-expansion-panel>
                        }
                    </div>

                    @if (productDetail.prodottiCorrelati?.length) {
                        <span class="title-medium emphasized section-title">{{ 'products.ui.prodottiSimili' | transloco }}</span>

                        <div class="related-products-grid">
                            @for (related of productDetail.prodottiCorrelati; track related.idProdotto) {
                                <mat-card class="related-product-card">
                                    <mat-card-content>
                                        <div class="related-product-header">
                                            <span class="body-medium emphasized related-product-name">{{ related.nomeProdotto }}</span>
                                            <mat-chip disabled class="related-product-business" [class.oil]="related.business === 'Oil'" [class.non-oil]="related.business === 'NonOil'">
                                                {{ related.business === 'Oil' ? 'Oil' : 'Non Oil' }}
                                            </mat-chip>
                                        </div>

                                        <span class="body-small related-product-plc">{{ related.plc1 }} - {{ related.plc2 }}</span>

                                        <div class="related-product-footer">
                                            <span class="title-medium emphasized">
                                                {{ related.prezzo | translocoCurrency: 'symbol' : { minimumFractionDigits: 4, maximumFractionDigits: 4 } }}
                                            </span>
                                            <button matButton (click)="openRelatedProduct(related.idProdotto)">
                                                {{ 'products.ui.infoProdotto' | transloco }}
                                            </button>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            }
                        </div>
                    }
                </div>
            </mat-tab>
            <!-- Tab nascosto per il rilascio, da rimettere
            <mat-tab [label]="'products.ui.statistiche' | transloco">
                <div class="tab-content">
                    TODO: statistiche prodotto
                </div>
            </mat-tab>
            -->
            <mat-tab [label]="'products.ui.documenti' | transloco">
                <div class="tab-content">
                    <mat-button-toggle-group
                        class="documents-type-toggle"
                        hideSingleSelectionIndicator="true"
                        [value]="documentTypeFilter"
                        (change)="documentTypeFilter = $event.value">
                        <mat-button-toggle value="">{{ 'products.ui.tutti' | transloco }}</mat-button-toggle>
                        <mat-button-toggle value="PDS">PDS</mat-button-toggle>
                        <mat-button-toggle value="SDS">SDS</mat-button-toggle>
                    </mat-button-toggle-group>

                    <div class="documents-grid">
                        @for (doc of filteredDocuments; track doc.idAsset) {
                            <mat-card class="document-card">
                                <mat-card-content>
                                    <div class="document-card-icon">
                                        <i class="fa-regular fa-file-pdf"></i>
                                    </div>

                                    <div class="document-card-info">
                                        <span class="label-medium emphasized document-card-name">{{ doc.nomeFile }}</span>
                                        <mat-chip class="document-card-type" disabled>{{ doc.tipo }}</mat-chip>
                                    </div>

                                    <button
                                        mat-icon-button
                                        type="button"
                                        (click)="downloadDocument(doc)"
                                        [attr.aria-label]="'products.ui.scaricaDocumento' | transloco">
                                        <i class="fa-regular fa-download"></i>
                                    </button>
                                </mat-card-content>
                            </mat-card>
                        }
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    }

    <button matButton="filled" class="cart-floating-button" (click)="cart.open()"
        [matBadge]="cart.cart()?.numeroRighe"
        [matBadgeHidden]="!cart.cart()?.numeroRighe"
        matBadgeColor="warn"
        matBadgePosition="above after">
        <i class="fa-regular fa-cart-shopping"></i>
        {{ 'products.ui.carrello' | transloco }}
    </button>

</ng-container>
